var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"side-panel_item-block",style:({ padding: _vm.padding })},[_c('div',{staticStyle:{"width":"100%"}},[_vm._t("default")],2),(_vm.showChevron)?_c('img',{staticClass:"side-panel_item-block_chevron",attrs:{"src":require("@/assets/icons/ic-chev-e.svg")}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }